<template>
    <div id="app">
        <div class="head-box" v-if="!$route.meta.showTabBar">
            <span @click="goBack"></span>
            <div>{{ titleName }}</div>
            <b @click="goIndexCm"></b>
        </div>
        <div @click="miniDiversionAlert('true')" class="mini-diversion" v-if="$route.meta.showTabBar&&isShowbool">
            <div>
                <i></i>
                <span>微信搜索“DC竞赛”小程序，快速玩转竞赛！</span>
                <b @click.stop="()=>{isShowbool=false}"></b>
            </div>
        </div>
        <div class="tabBar" v-if="$route.meta.showTabBar">
            <router-link to="/index">
                <img :src="'/index'===$route.path?tabBarArr[0].selected:tabBarArr[0].normal">
                <span :class="'/index'===$route.path?'selected':''">首页</span>
            </router-link>
            <router-link to="/competition">
                <img :src="'/competition'===$route.path?tabBarArr[1].selected:tabBarArr[1].normal">
                <span :class="'/competition'===$route.path?'selected':''">{{ $t('dc_lang.竞赛') }}</span>
            </router-link>
            <router-link to="/mine">
                <img :src="'/mine'===$route.path?tabBarArr[2].selected:tabBarArr[2].normal">
                <span :class="'/mine'===$route.path?'selected':''">我的</span>
            </router-link>
        </div>
        <router-view v-if="isRouterShow"/>
        <div class="mini-code-outer" v-if="isShowAlert=='true'">
            <div class="mini-code">
                <span>微信搜索“DC竞赛”小程序</span>
                <span>或扫描下方二维码</span>
                <span>开启更便捷的DC竞赛之旅</span>
                <div class="img-box">
                    <img src="/static/img/common/mini-code.jpg">
                </div>
                <div class="btn" @click="miniDiversionAlert('false')">{{ $t('dc_lang.好的') }}</div>
            </div>
        </div>
        <alert ref="alertCompo"></alert>
        <toast ref="toastCompo"></toast>
        <!--        <ShowLoading ref="commonLoading" v-if="loading"></ShowLoading>-->
        <dc-loading ref="loadingCompo"></dc-loading>
    </div>
</template>

<script>
import Vue from 'vue'
import alert from './components/common/alert/alert'
import toast from './components/common/toast/toast'
import api from './api/api'
// import ShowLoading from './components/common/dc-loading/dc-loading'

export default {
  name: 'App',
  components: {
    alert,
    toast
    // ShowLoading
  },
  provide: function () {
    return {
      appReload: this.reload
    }
  },
  data () {
    return {
      titleName: 'DC竞赛',
      isShowAlert: false,
      isShowbool: true,
      isRouterShow: true,
      tabBarArr: [
        {
          normal: '../static/img/index/tab-bar-index.png',
          selected: '../static/img/index/tab-bar-index-select.png'
        },
        {
          normal: '../static/img/index/tab-bar-cmpt.png',
          selected: '../static/img/index/tab-bar-cmpt-select.png'
        },
        {
          normal: '../static/img/index/tab-bar-user.png',
          selected: '../static/img/index/tab-bar-user-select.png'
        }
      ],
      loginUser: {},
      loading: false
    }
  },
  watch: {
    '$route': 'jugeAgree'
  },
  mounted () {
    Vue.prototype.$loading = this.$refs.loadingCompo.trigger
    var day1 = this.common.getCookieSync('alertTime') ? this.common.getCookieSync('alertTime') : ''
    var day2 = new Date().getTime()
    if (day1 == '' || (day2 - day1) / (1000 * 60 * 60 * 24) > 1) {
      this.isShowbool = true
    } else {
      this.isShowbool = false
    }
    this.common.addCookieSync('alertTime', new Date().getTime())

    if (this.common.getCookieSync('loginUser') && this.common.getCookieSync('loginUser') != '') {
      this.loginUser = JSON.parse(this.common.getCookieSync('loginUser'))
    }
    if (!this.loginUser.id || this.loginUser.id == null) {
      this.init()
    }
  },
  methods: {
    // jugeAgree () {
    //   const me = this
    //   const pathName = window.location.pathname
    //   if (pathName == '/privacyPolicy') {
    //     return
    //   }
    //   api.judgeUserAgreeRules({}).then((res) => {
    //     me.common.axiosSuccessFun({
    //       this: me,
    //       fail: false,
    //       failBack (resp) {
    //         if (resp.msg === '未同意隐私政策') {
    //           me.$refs.alertCompo.setProps({
    //             alertTitle: me.alertTitle,
    //             rule: '我已阅读并同意<a href="/privacyPolicy" target="_blank" style="color: #4DA6FF;">《DC隐私权政策》</a>',
    //             alertMessage: '尊敬的DC竞赛用户，我们于近日上线了新的<a href="/privacyPolicy" target="_blank" style="color: #4DA6FF;">《DC隐私权政策》</a>，为便于您的使用，请仔细阅读并同意相关政策。若不同意，将无法继续使用我们的产品和服务。',
    //             sureTxt: '确定',
    //             singleBtn: true,
    //             select: false,
    //             isSureAlertFun: false,
    //             sureFun: function () {
    //               if (this.select) {
    //                 this.show = false
    //
    //                 api.agreeUserRules({}).then((res) => {
    //                   me.common.axiosSuccessFun({
    //                     this: me,
    //                     callBack (res) {
    //
    //                     }
    //                   }, res.data)
    //                 })
    //               }
    //             }
    //           })
    //         }
    //       },
    //       callBack (res) {
    //
    //       }
    //     }, res.data)
    //   })
    // },
    checkLoginStatusAjaxFun: function (callBack) {
      api.unReadNumUrl({type: '0'}).then(response => {
        callBack()
      })
    },
    reload: function () {
      this.isRouterShow = false
      this.$nextTick(function () {
        this.isRouterShow = true
      })
    },
    miniDiversionAlert (bool) {
      this.isShowAlert = bool
      if (bool == 'false') {
        this.isShowbool = false
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    // 点击回到首页
    goIndexCm () {
      this.$router.push('/index')
    },
    init () {
      const me = this
      let token = this.common.getCookie('token')
      me.$loading(true)
      if (token) {
        this.ssoLoginFun(token)
      } else {
        let time = new Date().getTime()
        if (process.env.NODE_ENV == 'test' || process.env.NODE_ENV == 'development') {
          me.common.jsonpFun('http://sso.dc.com/sso-test.js?' + time)
        } else {
          me.common.jsonpFun('https://sso.datacastle.cn/sso.js?' + time)
        }
          // me.common.jsonpFun('http://sso.dc.com/sso-test.js?' + time)
        window.jsonpCallback = function (res) {
          if (res.ticketToken) {
            me.ssoLoginFun(res.ticketToken)
          } else {
            me.$loading(false)
          }
        }
      }
    },
    ssoLoginFun (token) {
      const me = this
      api.ssoLogin({
        token: token
      }).then((responses) => {
        me.common.axiosSuccessFun({
          this: me,
          fail: false,
          failBack (res) {
            me.$loading(false)
            me.common.delCookieSync('loginUser')
            me.common.setCookie('token', '')
            if (res.msg === 'token已失效') {
              me.init()
            }
          },
          callBack (res) {
            me.loading = false
            // 用户信息
            let loginUser = {
              loginStatus: true,
              id: res.data.userId,
              userName: res.data.userName,
                avatar: res.data.avatar,
                session_dc: res.data.session_dc,
            }
            me.common.addCookieSync('loginUser', JSON.stringify(loginUser))
            me.common.setCookie('token', '')
            window.location.reload()
          }
        }, responses.data)
      }).catch((resp) => {
        me.common.axiosFailFun({
          this: me
        }, resp)
      })
    }
  }
}
</script>

<style lang="scss">
.head-box {
    height: 88px;
    line-height: 88px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;

    span {
        float: left;
        margin-left: 30px;
        // margin: 26px 0 0 30px;
        width: 22px;
        height: 40px;
        background: url("/static/img/common/backArrow.png") no-repeat 0 0;
        background-size: cover;
    }

    div {
        font-size: 36px; /*px*/
        font-weight: bold;
        width: 500px;
        padding-left: 20px;
        height: 87px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 0 auto;
        text-align: center;
        color: #030303;
    }

    // 新增返回首页图标
    b {
        float: right;
        width: 48px;
        height: 48px;
        margin-right: 30px;
        background: url("/static/img/common/home_1.png") no-repeat 0 0;
        background-size: cover;
    }
}

.mini-diversion {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #FEFCEB;
    z-index: 10000;

    div {
        padding: 20px 30px;

        i {
            float: left;
            width: 34px;
            height: 40px;
            background: url("/static/img/index-page/index-head-icon.png") no-repeat 0 0;
            background-size: 34px auto;
        }

        span {
            color: #FFB746;
            padding-left: 20px;
            font-size: 28px;
        }

        b {
            float: right;
            width: 26px;
            height: 26px;
            background: url("/static/img/index-page/index-close.png") no-repeat 0 0;
            background-size: cover;
        }
    }
}

.mini-code-outer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 10001;

    .mini-code {
        width: 580px;
        height: 636px;
        box-sizing: border-box;
        margin: 300px auto;
        background: #fff;
        border-radius: 12px;
        text-align: center;
        padding: 60px 50px 50px;

        span {
            display: block;
            font-size: 28px; /*px*/
            color: #17181A;
            line-height: 40px;
        }

        .img-box {
            width: 258px;
            height: 258px;
            margin: 30px auto;

            img {
                max-width: 100%;
                max-height: 100%;
                margin: 0 auto;
            }
        }

        .btn {
            background: #4DA6FF;
            box-shadow: 0 12px 24px 0 rgba(135, 156, 200, 0.25);
            border-radius: 6px;
            height: 88px;
            line-height: 88px;
            color: #fff;
            font-size: 30px; /*px*/
        }
    }
}

.tabBar {
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    height: 98px;
    background-color: #ffffff;
    z-index: 99;

    a {
        flex: 1;
        text-align: center;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        font-size: 20px; /*px*/
        color: #B8C4CC;

        img {
            margin-bottom: 8px;
            width: 48px;
            height: 48px;
        }
    }

    .selected {
        color: #4DA6FF;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue